/**
 * Query keys for notification-related queries and mutations
 * Used with React Query to cache and invalidate queries
 */

export const notificationKeys = {
  // Base key for all notification-related queries
  all: ["notifications"] as const,

  // Key for listing notifications with optional filters
  list: (filters?: { is_read?: boolean; page?: number; take?: number; order?: string }) =>
    filters
      ? ([...notificationKeys.all, "list", filters] as const)
      : ([...notificationKeys.all, "list"] as const),

  // Key for a specific notification details
  detail: (notificationId: string | number) =>
    [...notificationKeys.all, "detail", notificationId] as const,

  // Key for total notification counts
  total: () => [...notificationKeys.all, "total"] as const,

  // Key for notification counts by status
  counts: () => [...notificationKeys.all, "counts"] as const,
};
